import React from 'react';
import styled from 'styled-components';


const StyledArrowBar= styled.div`
	position: absolute;
	width: 50%;
	height: 45px;
	bottom: 0;
	background: #fff;
	opacity: 0.9;
	.af-arrow-up,
	.af-arrow-down {
		position: absolute;
		border: none;
		background: none;
		bottom: 0px;
		padding: 6px;
		svg {
			width: 30px;
			height: 15px;
		}
	}
	.af-arrow-up {
		right: 15px;
	}
	.af-arrow-down {
		left: 15px;
	}


  @media (max-width: 576px) {
  	width: calc(100% - 18px);
  }

`;

const ArrowBar = (props) => {

	const { currentStep, numberOfSteps, arrowDownHandler, arrowUpHandler } = props;

	const activeButtonStyle = { opacity: 1, pointerEvents: 'all' };
	const passiveButtonStyle ={ opacity: 0.3, pointerEvents: 'none' };
	const styleArrowDown = currentStep < numberOfSteps ? activeButtonStyle : passiveButtonStyle;
	const styleArrowUp = currentStep > 1 ? activeButtonStyle : passiveButtonStyle;

	return (
		<StyledArrowBar>

			<button className="af-arrow-down" onClick={arrowDownHandler} style={styleArrowDown} aria-label="scroll down" >
				<svg width="30px" height="15px">
					<polyline points="6,3 15,12 24,3" fill="none" stroke="#333" strokeWidth="2" />
				</svg>
			</button>

			<button className="af-arrow-up" onClick={arrowUpHandler} style={styleArrowUp} aria-label="scroll up">
				<svg width="30px" height="15px">
					<polyline points="6,12 15,3 24,12" fill="none" stroke="#333" strokeWidth="2" />
				</svg>
			</button>

		</StyledArrowBar>
	)
}

export default ArrowBar;



// WEBPACK FOOTER //
// ./src/components/ArrowBar/ArrowBar.js